import { getDataService } from '../services'

export default (recordId) => {
  return new Promise(async (resolve, reject) => {
    await getDataService.getActivityRecord(recordId)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
